import { render, staticRenderFns } from "./y_choose_account.vue?vue&type=template&id=2c8776fa&scoped=true"
import script from "./y_choose_account.vue?vue&type=script&lang=js"
export * from "./y_choose_account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8776fa",
  null
  
)

export default component.exports